// pluralize :: String -> String -> Number -> String
export const pluralize = (singular: string, plural: string) => (count: number) =>
  count === 1 ? `${count} ${singular}` : `${count} ${plural}`;

export const replaceAll = (str: string, needle: string, replace: string) =>
  str.replace(new RegExp(needle, "g"), replace);
